module.exports = __webpack_public_path__ + "static/media/blackPin.3ae80142.svg";